"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _core = _interopRequireDefault(require("lodash/core"));

var _slugify = _interopRequireDefault(require("slugify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(user) {
  var resolved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _core.default.map([{
    // Document manager
    name: 'Document Manager',
    scopes: ['LegalDocument']
  }, {
    // Asset manager
    name: 'Asset Manager',
    scopes: ['LegalDocument'],
    conditions: {}
  }, {
    // Facility manager
    name: 'Facility Manager',
    scopes: ['LegalDocument'],
    conditions: {}
  }, {
    name: 'Admin',
    scopes: ['User', 'ProjectUpdate']
  }, {
    name: 'Safety Manager RD',
    scopes: ['ProjectReadSafetyRD']
  }, {
    name: 'Safety Manager CDE',
    scopes: ['ProjectReadSafetyCDE']
  }], function (item) {
    return _objectSpread({}, item, {
      slug: (0, _slugify.default)(item.name)
    });
  });
}

;